import moment from 'moment';
import { mapObjIndexed, evolve } from 'ramda';
import { useFirebase } from '../states/firebase-state';
import { iList, iNote } from '../shared/interfaces';

export const useItemNotes = (
  deviceOrFence: 'device' | 'fence',
  itemId: string
): iList<iNote> => {
  const notesPath = `notes/${deviceOrFence}/${itemId}/`;

  const [notes] = useFirebase<iList<iNote>>(
    notesPath,
    mapObjIndexed(evolve({ date: moment }))
  );

  return notes || {};
};

